export default __webpack_public_path__ + "static/media/attendance-notebook.5d6f1d13.svg";